import React from "react";

const TitleStatus = (status: any) => {
    return (
        <p className="title__status">Требует подтверждения</p>
    );
}

export default TitleStatus;
